import { combineReducers } from 'redux';
import shopCart from './shopCartReducers';
import planList from './planListReducers';
import userReducer from './userReducers';
import localeLanguage from './languageReducers';

const reducer = combineReducers({ shopCart, planList, userReducer, localeLanguage });

export default reducer;
